import { useEffect } from 'react';
import { PendingCryptoPaymentModal } from '@/components/payments/pending-crypto-payment-modal';
import {
  removeStreamCryptoPayment,
  updateStreamCryptoPaymentState,
} from '@/components/streams/toggle-paid-stream-subscription/stream-crypto-payment-var';

export const PendingStreamCryptoPaymentModal = ({
  streamId,
  invoiceUrl,
}: {
  streamId: string;
  invoiceUrl?: string | null;
}) => {
  useEffect(() => {
    const bc = new BroadcastChannel(`stream:invoice-url`);

    bc.onmessage = (event) => {
      updateStreamCryptoPaymentState(event.data.streamId, {
        invoiceUrl: event.data.invoiceUrl,
      });
    };

    return () => {
      bc.close();
    };
  }, []);

  return (
    <PendingCryptoPaymentModal
      message="Once your payment is confirmed, you'll get access to the stream."
      onCancel={() => {
        removeStreamCryptoPayment(streamId);
      }}
      invoiceUrl={invoiceUrl}
    />
  );
};
